<p>{{ versionName }} ({{ commitSha }})</p>
